import { useCallback, useRef, useState } from 'react';

export function useCreatePromise(onCreate) {
  const { current: statics } = useRef({});
  const [lastCreatedPromise, setLastCreatedPromise] = useState({});

  const createPromise = useCallback((...params) => {
    const promise = new Promise((resolve, reject) => {
      statics.resolve = resolve;
      statics.reject = reject;
    });

    if (onCreate) {
      onCreate(
        {
          resolvePromise: statics.resolve,
          rejectPromise: statics.reject,
        },
        ...params
      );
    }

    setLastCreatedPromise(promise);

    return promise;
  }, [statics, onCreate, setLastCreatedPromise]);

  const resolveLastCreatedPromise = useCallback((...params) => {
    if (statics.resolve) {
      statics.resolve(...params);
    }
  }, [statics]);

  const rejectLastCreatedPromise = useCallback((...params) => {
    if (statics.reject) {
      statics.reject(...params);
    }
  }, [statics]);

  return [
    {
      lastCreatedPromise,
    },
    {
      createPromise,
      resolveLastCreatedPromise,
      rejectLastCreatedPromise,
    },
  ];
}
